import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Contact } from '@shared/models/contact.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ContactFormService {
    private http = inject(HttpClient);

    isSending$ = new BehaviorSubject(false);

    sendMeetMessage(userCredentials: Contact): Observable<boolean> {
        return this.http.post<Contact>('api/public/contact-form', userCredentials).pipe(map(() => true));
    }
}
